import Vue from 'vue';
import App from './App.vue';
import MitConfigService from './services/MitConfigService.js';

import router from './router';

Vue.config.productionTip = false

import Vuetify from "vuetify";

import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);

import colors from 'vuetify/lib/util/colors';

//Event bus for application to listen on.
//use this conservatively, meants for app level observer pattern updates
//Example if a user changes and multiple components need to update
export const MitEventBus = new Vue();
MitEventBus.EVENTS = {
  USER_SERVICE__USER_CHANGED:'mit-user-service--user-changed'
};

//bootstrap the configuration service
const promiseConfig = MitConfigService.fetch();
const promiseFeature = MitConfigService.fetchFeatures()

Promise.all([promiseConfig, promiseFeature]).then(data => {
  console.log('Successfully Loaded App Configuration');
  new Vue({
    beforeCreate: function() {
    },
    router,
    vuetify: new Vuetify({
      theme: {
        dark: false,
        options: { customProperties: true }//add variables for access in css or scss
      }
    }),
    render: h => h(App),
  }).$mount('#app')
})
.catch((error) => {
  console.log('An error occurred trying to get the configuration', error);
});
import "./last.css";
